import useAuth from '@/stores/auth';

export function hasExpiredAuthSession(): boolean {
  const authStore = useAuth();
  if (authStore.cookiesExpired) return true;

  const isExpired = authStore.tokenExpireTime !== null
    && authStore.tokenExpireTime <= Date.now();

  if (isExpired) authStore._authCookiesExpired(true);

  return isExpired;
}
